import { ElMessage } from "element-plus";
enum ToastType {
    SUCCESS = "success",
    WARNING = "warning",
    ERROR = "error",
    INFO = "info",
}

class Toast {
    doToast(text: String, type?: ToastType, customClass?: String) {
        // const currentRoute = router.currentRoute.value;
        ElMessage({
            type,
            message: text as string,
            grouping: true, // group messages;
            duration: 3000,
            offset: 64,
            customClass: customClass || `el-toast-custom-${type}`,
        });
    }
    success(text: String, customClass?: String) {
        return this.doToast(text, ToastType.SUCCESS, customClass);
    }
    warning(text: String, customClass?: String) {
        return this.doToast(text, ToastType.WARNING, customClass);
    }
    error(text: String, customClass?: String) {
        return this.doToast(text, ToastType.ERROR, customClass);
    }
    default(text: String, customClass?: String) {
        return this.doToast(text, ToastType.INFO, customClass);
    }
}

export const useToast = new Toast();
